import { TranslationsContext } from '@/context/Translations';
import { useContext } from 'react';

export const useTranslateKey = (key: string) => {
  const { translations } = useContext(TranslationsContext);
  return translations?.translations?.find(
    (translation) => translation.key === key
  )?.value;
};
